pill: "Now Accepting Pilot Partners"
headline: "We build AI that actually fits your <span class=\"ac\">industry.</span>"
subtext: "Banoffee is an AI-first agency closing the gap between cutting-edge automation and the industries that need it most — legal, HR, security, and beyond. We audit, design, and build custom AI layers that eliminate operational overhead for good."

actions:
  - label: "See Your Savings →"
    href: "#calculator"
    style: primary
  - label: "See What We Do"
    href: "#services"
    style: outline

capabilities:
  - icon: "🔍"
    iconClass: "i1"
    title: "Workflow Audits"
    body: "We map your manual processes end-to-end before recommending anything."
  - icon: "🤝"
    iconClass: "i2"
    title: "Domain Expert Network"
    body: "Legal, HR, and security practitioners validate every problem we solve."
  - icon: "⚙️"
    iconClass: "i3"
    title: "Precision AI Builds"
    body: "NLP, OCR, and reasoning systems built for your actual documents."
  - icon: "📈"
    iconClass: "i4"
    title: "Continuous Enablement"
    body: "We don't disappear. We monitor, iterate, and evolve as you grow."

stats:
  - value: "8+"
    label: "Years NLP &\nText Extraction"
  - value: "4"
    label: "Industry verticals\nin active exploration"
  - value: "100%"
    label: "Domain-validated\nproblem discovery"
  - value: "0"
    label: "Generic chatbots.\nEver."

trustBadges:
  - icon: "🔒"
    label: "NDA from Day One"
  - icon: "🏢"
    label: "On-Premise Available"
  - icon: "✅"
    label: "Domain Expert Validated"
  - icon: "🌏"
    label: "India & USA Operations"
